export default __webpack_public_path__ + "static/media/Titel_image_Philosophers_stone.04382c83.jpg";